import React, { CSSProperties } from "react";
import styled from "styled-components/macro";

type Density = "highest" | "high" | "normal" | "relaxed";

export interface FlexProps {
  column?: boolean;           // flex-direction = column
  wrap?: boolean;             // flex-wrap
  justifyContent?: "flex-start" | "flex-end" | "center" | "space-around" | "space-between" | "space-evenly";
  alignItems?: "flex-start" | "flex-end" | "center" | "stretch" | "baseline";
  alignContent?: "flex-start" | "flex-end" | "center" | "space-around" | "space-between" | "space-evenly" | "stretch" | "baseline";
  densityHor?: Density;          // space between items horizontally
  densityVer?: Density;          // space between items vertically

  basis?: string | number;    // flex-basis
  grow?: boolean | number;    // flex-grow
  shrink?: boolean | number;  // flex-shrink
  alignSelf?: "flex-start" | "flex-end" | "center" | "stretch" | "baseline";
  order?: number;

  className?: string;
  style?: CSSProperties;
  children?: JSX.Element | JSX.Element[] | string | number;
}

export default function Flex(props: FlexProps): JSX.Element {
  const { className, style, ...rest } = props;
  return <FlexWrapper {...rest} className={className} style={style}>
  </FlexWrapper>
}

const densityToUnit = (density: Density): string => {
  switch (density) {
    case "highest": return "0";
    case "high": return ".5em";
    case "normal": return "1em";
    case "relaxed": return "2em";
    default: return null;
  }
}

const densityProperty = (cssProp: string, density: Density): string => {
  const unit = densityToUnit(density);
  return unit ? `&> * + * { ${cssProp}: ${unit}; }` : '';
}

const FlexWrapper = styled.div<FlexProps>`
  display: flex;

  ${props => props.column ? 'flex-direction: column;' : ''}
  ${props => props.wrap ? 'flex-wrap: wrap;' : ''}
  ${props => props.justifyContent ? `justify-content: ${props.justifyContent};` : ''}
  ${props => props.alignItems ? `align-items: ${props.alignItems};` : ''}
  ${props => props.alignContent ? `align-content: ${props.alignContent};` : ''}

  ${props => props.basis ? `flex-basis: ${props.basis};` : ''}
  ${props => props.grow ? `flex-grow: ${props.grow};` : ''}
  ${props => props.shrink ? `flex-shrink: ${props.shrink};` : ''}
  ${props => props.alignSelf ? `align-self: ${props.alignSelf};` : ''}
  ${props => props.order ? `order: ${props.order};` : ''}

  ${props => props.densityHor ? densityProperty("margin-left", props.densityHor) : ''}
  ${props => props.densityVer ? densityProperty("margin-top", props.densityVer) : ''}
`;

